"use client";

import { ActionEnum, ItemType, UserDetails } from "@/graphql/schema";
import { useEffect, useRef } from "react";
import { callTrackActivity } from "./graphqlUtils";

export const TIME_ON_PAGE_THRESHOLD = 10_000;

const ITEM_TYPE_TO_ACTION_ENUM = {
    [ItemType.MEDIA]: ActionEnum.OPEN_MEDIA,
    [ItemType.NOTE]: ActionEnum.OPEN_NOTE,
};

const ActivityTracker = ({
    itemId,
    itemType,
    user,
}: {
    itemId: string;
    itemType: ItemType;
    user: UserDetails | null | undefined;
}) => {
    const isTracked = useRef(false);
    useEffect(() => {
        if (!user || !itemId || !itemType || isTracked.current) return;

        isTracked.current = true;

        const timeout = setTimeout(() => {
            callTrackActivity({
                itemId: itemId,
                type: itemType,
                action: ITEM_TYPE_TO_ACTION_ENUM[itemType],
            });
        }, TIME_ON_PAGE_THRESHOLD);

        return () => {
            // if the user navigates away from the page before the timeout is reached, clear the timeout
            clearTimeout(timeout);
        };
    }, [itemId, itemType]);

    return null;
};

export default ActivityTracker;
